import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getTotalNxacList } from "src/service/pay";
import { useState } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface IUseCheckProductAvailableProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useGetTotalNxacList({
  onSuccess,
  onError,
}: IUseCheckProductAvailableProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  // Nxac 정보
  const { isLoading: isLoadingNxacList, data: nxacList } = useQuery(
    ["getTotalNxacList", getProductFromSessionStorage()],
    async () => await getTotalNxacList(),
    {
      enabled: getProductFromSessionStorage() !== null,
      onSuccess: (res) => {},
      onError: onError ?? handleError,
    }
  );

  return { isLoadingNxacList, nxacList };
}
